package com.macrofocus.eflux.ui.mui

import com.macrofocus.eflux.EFlux
import com.macrofocus.eflux.components.EFluxModule
import com.macrofocus.eflux.theme.ThemeModule
import com.macrofocus.eflux.ui.AppContextProvider
import com.macrofocus.eflux.ui.EFluxApp
import js.objects.ReadonlyRecord
import js.objects.Record
import js.objects.unsafeJso
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.PropsWithChildren
import react.create
import tanstack.react.router.RouterProvider
import tanstack.react.router.*
import tanstack.router.core.RoutePath
import tanstack.router.core.Search

external interface ContentProps : PropsWithChildren {
    var eflux: EFlux
}

// 1. Define an interface for your route component's props if needed,
// or just use Props if EFluxModule handles it internally.
external interface EFluxRouteProps : Props {
    var eflux: EFlux // Replace with your actual EFlux type
}

fun createEFluxIndexComponent(eflux: EFlux) = FC<Props> {
    val (showTable, _) = useProperty(eflux.showTable)
    println("showTable $showTable")

    EFluxModule {
        this.eflux = eflux

        ThemeModule {
            AppContextProvider {
                this.dataLoader = eflux.dataLoader
                this.diagramTypeProperty = eflux.diagramTypeProperty
                this.showTableProperty = eflux.showTable

                EFluxApp {
                    val (diagramType, _) = useProperty(eflux.diagramTypeProperty)

                    this.dataLoader = eflux.dataLoader
                    this.diagramLoaders = eflux.dataLoader.diagramLoaders
                    this.diagramType = diagramType
                    this.showTable = eflux.showTable
                }
            }
        }
    }
}

external interface EFluxSearch : ReadonlyRecord<String, Any> {
    var date: String? // This will hold the "20260702_1235" string representation
}

val Content = FC<ContentProps> { props ->
    val component = createEFluxIndexComponent(props.eflux)

    println("Created component for ${props.eflux}")

    RouterProvider {
        val rootRoute = createRootRoute()
        val INDEX_PATH: RoutePath = RoutePath("/")

        val indexRoute = createRoute(
            options = RouteOptions(
                getParentRoute = { rootRoute },
                path = INDEX_PATH,
                validateSearch = { rawSearch ->
                    unsafeJso<EFluxSearch> {
                        val rawDate = rawSearch["date"]

                        if (rawDate != null) {
                            // Only assign the property if it actually exists in the URL
                            this.date = rawDate.toString()
                        }
                        // If it doesn't exist, we do NOT assign it at all.
                        // This keeps the underlying JS object clean: {} instead of { date: null }
                    }
                },
                component = component
            )
        )

        rootRoute.addChildren(
            arrayOf(
                indexRoute,
            ),
        )

        val router = createRouter(
            options = RouterOptions(
                routeTree = rootRoute,
            ),
        )
        this.router = router
    }
}

//fun isExpandAppBar(history: Location<*>) =
//    ("""(/[a-z]{2})?/(""" + escape("EFlux%20User%20Guide.html") + """"|development|terms)""").toRegex()
//        .matches(history.pathname)

//fun language(history: Location<*>) = Languages.valueOfCode(history.langCode()) ?: Languages.ENGLISH

//fun NavigateFunction.toRoot() = to("/")
//fun NavigateFunction.toUserGuide() = to("/doc/EFlux User Guide.html")
//fun History.toHowToUse() = to("/howtouse")
//fun History.toDevelopment() = to("/development")
//fun History.toTerms() = to("/terms")

//val Languages.basename: String
//    get() = when (this) {
//        Languages.ENGLISH -> ""
//        Languages.GERMAN -> "/de"
//        Languages.FRENCH -> "/fr"
//        Languages.ITALIAN -> "/it"
////        Languages.ROMANSH -> "/rm"
//    }

//private fun Location<*>.langCode() = Languages.values().let { languages ->
//    val c = pathname.split("/")[1]
//
//    languages.find { it.code == c }?.code ?: ""
//}

//private fun NavigateFunction.to(path: String) = push("${langCode().takeIf(String::isNotBlank)?.let { "/$it" } ?: ""}$path")

